import { UserOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Row } from 'antd';
import { useSecurityStrategyConfig } from 'client/components/schema/config/ClientConfigModule';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ItaliaButton } from '../open-web/italia-button/ItaliaButton';

const userIco = require('./img/user.png').default;

interface ISoapLdapLoginButtonProps {}

export function SoapLdapLoginButton(props: ISoapLdapLoginButtonProps) {
  const { t } = useTranslation();
  const hasSoapLdapStrategy = useSecurityStrategyConfig('soap-ldap');

  if (!hasSoapLdapStrategy) {
    return null;
  }

  return (
    <Row justify="center">
      <Col span={24}>
        <Divider style={{ padding: '0px 0 24px 0' }}>
          {t(
            'user.login.login-button-employee-access-divider',
            'ACCESSO DIPENDENTI'
          )}
        </Divider>
      </Col>
      <Col>
        <Link to="/utente/login/dipendenti">
          <ItaliaButton
            image={userIco}
            text={t('user.login.employee', 'Login Dipendenti')}
          />
        </Link>
      </Col>
    </Row>
  );
}
